import { apiCall, apiCallGeneric } from "../service/api-service";

// Menus in the admin role screen. Every module built in the Module Builder
// shares the "Custom Modules" permissions.
// ponytail: one permission set for all custom modules; per-module permissions
// need org-scoped menus in the admin service (menus are global per application).
export const MODULE_BUILDER = "Module Builder";
export const CUSTOM_MODULES = "Custom Modules";

// Fired after a module is saved or deleted so the sidebar reloads its menu.
export const CUSTOM_MODULES_CHANGED = "custom-modules-changed";

export const getCustomModulesApi = () => apiCall("GET", "custom_module");

// Calls an autocomplete source the way the dropdown will (`term` param), so the
// builder can check a custom suggestion URL before saving.
export const testSuggestionsApi = (url) => apiCallGeneric("GET", url, null, { params: { term: "" } });

export const getCustomModuleApi = (slug) => apiCall("GET", `custom_module/${slug}`);

export const saveCustomModuleApi = (id, data) =>
  id ? apiCall("PUT", `custom_module/${id}`, data) : apiCall("POST", "custom_module", data);

export const getRecordsApi = (slug, params) => apiCall("GET", `custom_module/${slug}/records`, null, { params });

export const exportRecordsApi = (slug, params) => apiCall("GET", `custom_module/${slug}/records/export`, null, { params });

export const getRecordApi = (slug, id) => apiCall("GET", `custom_module/${slug}/records/${id}`);

export const saveRecordApi = (slug, id, data) =>
  id
    ? apiCall("PUT", `custom_module/${slug}/records/${id}`, data)
    : apiCall("POST", `custom_module/${slug}/records`, data);

// One file for an attachment field, as a data URL; returns { file: { path, name, size, type, url } }.
export const uploadRecordFileApi = (slug, field, name, content) =>
  apiCall("POST", `custom_module/${slug}/upload`, { field, name, content });

export const bulkDeleteRecordsApi = (slug, ids) => apiCall("DELETE", `custom_module/${slug}/records`, { ids });

export const runRecordActionApi = (slug, id, index) =>
  apiCall("PUT", `custom_module/${slug}/records/${id}/action/${index}`);

export const updateRecordFieldApi = (slug, id, key, value) =>
  apiCall("PUT", `custom_module/${slug}/records/${id}/field`, { key, value });

export const getRelatedRecordsApi = (slug, id) => apiCall("GET", `custom_module/${slug}/records/${id}/related`);

export const getRecordHistoryApi = (slug, id) => apiCall("GET", `custom_module/${slug}/records/${id}/history`);

export const addRecordNoteApi = (slug, id, note) => apiCall("POST", `custom_module/${slug}/records/${id}/notes`, { note });
